import { type FC, type MouseEvent, type ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
// styles
import dibsCss from 'dibs-css';
import styles from './SearchBarTerm.module.css';

type Props = {
    term: string;
    termElements: ReactNode;
    href: string;
    handleRowClick: (term: string, href: string, event: MouseEvent) => void;
    cursorHighlightId?: string;
    id?: string;
    type?: string | null;
};

export const SearchBarTerm: FC<Props> = ({
    href,
    term,
    handleRowClick,
    cursorHighlightId,
    id,
    termElements,
}) => {
    const searchBarTermClasses = classnames(styles.hoverBackground, {
        [styles.active]: id === cursorHighlightId,
    });

    return (
        <div className={searchBarTermClasses}>
            <Link
                dataTn="search-bar-term"
                className={classnames(
                    styles.linkItem,
                    dibsCss.textBodyMediumNormal,
                    dibsCss.wFull,
                    dibsCss.block,
                    dibsCss.textNoir
                )}
                href={href}
                onClick={e => {
                    e.preventDefault();
                    handleRowClick(term, href, e);
                }}
            >
                {termElements}
            </Link>
        </div>
    );
};
